export default "__VITE_ASSET__BdF$vqcO__"